export type OutboundRequestObserverStartEvent = {
  method: string;
  url: string;
};

export type OutboundRequestObserverFinishEvent = {
  durationMs: number;
  isError?: boolean;
  method: string;
  requestKey?: unknown;
  status?: number;
  url: string;
};

export type OutboundRequestObserver = {
  onFinish?: (event: OutboundRequestObserverFinishEvent) => Promise<void> | void;
  onStart?: (event: OutboundRequestObserverStartEvent) => Promise<unknown> | unknown;
};

let outboundRequestObserver: OutboundRequestObserver | null = null;

export function setOutboundRequestObserver(observer: OutboundRequestObserver | null): void {
  outboundRequestObserver = observer;
}

export const trackOutboundRequestStart = async (
  method: string,
  url: string,
): Promise<(status?: number, isError?: boolean) => Promise<void>> => {
  const startedAt = Date.now();
  const requestKey = await outboundRequestObserver?.onStart?.({ method, url });

  return async (status?: number, isError = false) => {
    const durationMs = Date.now() - startedAt;
    await outboundRequestObserver?.onFinish?.({ durationMs, isError, method, requestKey, status, url });
  };
};
